import {
  pulse_check_submission_notifications_path,
  request_intro_feedback_notifications_path,
  settings_notification_path,
} from "@routes/routes";
import {
  NotificationSettingsResponse,
  NotificationSettingsShowResponse,
  NotificationUserInfoResponse,
} from "@tsTypes/index";
import api from "./request";

export const fetchNotificationSettings = async (
  userId: number
): Promise<NotificationSettingsShowResponse> => {
  const responseJson = await api.get(`/notification_settings/${userId}`);
  return responseJson.data;
};

export const updateNotificationSetting = async (
  userId: number,
  key: string,
  enabled: boolean
): Promise<NotificationSettingsResponse> => {
  const responseJson = await api.patch(`/notification_settings/${userId}`, {
    key: key,
    enabled: enabled,
  });
  return responseJson.data;
};

export const fetchUserInfoFromNotification = async (
  notificationId: string
): Promise<NotificationUserInfoResponse> => {
  const responseJson = await api.get(`/notifications/${notificationId}/user_info`);
  return responseJson.data;
};

export const fetchNotificationSettingsFromNotification = async (
  notificationId: string
): Promise<NotificationSettingsResponse> => {
  const responseJson = await api.get(settings_notification_path(notificationId));
  return responseJson.data;
};

export const sendRequestIntroFeedback = async (data: {
  message: string;
  solutionSlug: string;
  solutionTitle: string;
  organizationName?: string;
}): Promise<{ success: boolean }> => {
  const responseJson = await api.post(request_intro_feedback_notifications_path(), {
    message: data.message,
    solution_slug: data.solutionSlug,
    solution_title: data.solutionTitle,
    organization_name: data.organizationName,
  });
  return responseJson.data;
};

export const submitPulseCheck = async ({
  description,
  industryApplications,
  expertise,
  trlGroupings,
  shouldHideCompanyName,
}: {
  description: string;
  industryApplications: string[];
  expertise: string[];
  trlGroupings: string[];
  shouldHideCompanyName: boolean;
}): Promise<{ success: boolean }> => {
  const responseJson = await api.post(pulse_check_submission_notifications_path(), {
    description,
    industry_applications: industryApplications,
    expertise,
    trl_groupings: trlGroupings,
    should_hide_company_name: shouldHideCompanyName,
  });
  return responseJson.data;
};
